import { AutoLinkNode, LinkNode } from '@lexical/link';
import { ListItemNode, ListNode } from '@lexical/list';
import { HeadingNode, QuoteNode } from '@lexical/rich-text';
import {
  type Klass,
  type LexicalNode,
  type LexicalNodeReplacement,
  ParagraphNode,
  TextNode,
} from 'lexical';

import { AutocompleteNode } from '../../editor/nodes/autocomplete-node';
import { ExtendedTextNode } from '../../editor/nodes/extended-text-node';
import { ImageNode } from '../../editor/nodes/image-node';
import { LineHeightNode } from '../../editor/nodes/line-height-node';

export const nodes: ReadonlyArray<Klass<LexicalNode> | LexicalNodeReplacement> = [
  ParagraphNode,
  HeadingNode,
  QuoteNode,
  ListNode,
  ListItemNode,
  LinkNode,
  AutoLinkNode,
  ImageNode,
  LineHeightNode,
  AutocompleteNode,
  ExtendedTextNode,
  {
    replace: TextNode,
    with: (node: TextNode) => new ExtendedTextNode(node.__text),
    withKlass: ExtendedTextNode,
  },
];
